import { PageType } from 'types/analytics'

import { NewsletterOrigin } from '../../constants'

export const getOrigin = (pageType: PageType) => {
	const landingPages = [
		PageType.DiscoverHome,
		PageType.DiscoverCategory,
		PageType.DiscoverCategoryBrand,
		PageType.Landings,
	]

	return landingPages.includes(pageType)
		? NewsletterOrigin.LANDING
		: NewsletterOrigin.FOOTER
}
